module.exports = __webpack_public_path__ + "img/tipo.c375ba3f.svg";